(function () {
    'use strict';

    angular
        .module('app')
        .controller('ContractsListController', ContractsListController);

    ContractsListController.$inject = ['API', 'alert', 'debug', 'ListViewSearchExtension', '$stateParams',];

    function ContractsListController(API, alert, debug, ListViewSearchExtension, $stateParams) {
        var vm = this;
        ListViewSearchExtension.extendScope(vm);
        vm.listObject.filter = {
            contractType: '',
        };
        vm.loadingState = {
            contractIsLoading: false,
            contractTypesAreLoading: false,
        };
        vm.openRemoveModal = openRemoveModal;
        vm.keyUp = keyUp;
        vm.loadResources = loadResources;
        vm.contractTypes = [];

        activate();

        function activate() {
            if ($stateParams.searchObject) {
                vm.loadParams(JSON.parse($stateParams.searchObject));
            }
            loadContractTypes();
            loadResources(true);
        }

        function openRemoveModal() {
            alert.confirm('remove-something');
        }

        function loadContractTypes() {
            vm.loadingState.contractTypesAreLoading = true;
            API.ContractType.get().$promise.then(function (response) {
                vm.contractTypes = response.items;
            }, function (response) {
                debug.log(response);
            })
            .finally(function() {
                vm.loadingState.contractTypesAreLoading = false;
            });
        }

        function loadResources(skipCharacterLimit) {
            var promise = null;

            var searchObject = {
                'expand': 'type',
                'page': vm.listObject.page,
                'per-page': vm.listObject.perPage,
            };

            if (vm.listObject.filter.contractType) {
                searchObject.type__name = vm.listObject.filter.contractType;
            }

            if (vm.listObject.searchTerm && (vm.listObject.searchTerm.length > 2 || skipCharacterLimit)) {
                searchObject.q = vm.listObject.searchTerm;
                promise = API.Contract.search(searchObject).$promise;
            } else if (vm.listObject.searchTerm.length === 0) {
                promise = API.Contract.search(searchObject).$promise;
            }

            vm.onSearch();

            if (promise) {
                vm.loadingState.contractIsLoading = true;
                promise.then(function (response) {
                    vm.contracts = response.items;
                    debug.log(response);
                    vm.listMeta = response._meta;
                }, function (response) {
                    debug.log(response);
                })
                .finally(function() {
                    vm.loadingState.contractIsLoading = false;
                });
            }
        }

        function keyUp(event) {
            if (event.keyCode === 13) {
                loadResources(true);
            }
        }
    }
})();